import moment from 'moment'
import * as R from 'ramda'

export const startDateTimeKey = 'startDateTime'
export const endDateTimeKey = 'endDateTime'

export const TYPE_SET_INITIAL = 'TYPE_SET_INITIAL'
export const TYPE_UPDATE_PARTIAL = 'TYPE_UPDATE_PARTIAL'
export const TYPE_UPDATE_PARTIAL_MULTIPLE = 'TYPE_UPDATE_PARTIAL_MULTIPLE'
export const TYPE_UPDATE_ADDRESS = 'TYPE_UPDATE_ADDRESS'
export const SET_START_MIN_DATE = 'SET_START_MIN_DATE'
export const SET_OVERRIDDEN = 'SET_OVERRIDDEN'
export const SET_TIMEZONE_AND_ADDRESS = 'SET_TIMEZONE_AND_ADDRESS'
export const SET_MAX_DATE = 'SET_MAX_DATE'
export const ON_SHOW_END_DATE_TIME = 'ON_SHOW_END_DATE_TIME'
export const TYPE_CLEAR_DATE_ERROR = 'TYPE_CLEAR_DATE_ERROR'
export const SET_TIMEZONE_START = 'SET_TIMEZONE_START'
export const SET_TIMEZONE_END = 'SET_TIMEZONE_END'
export const ON_CHANGE_DATE = 'ON_CHANGE_DATE'
export const SET_MIN_END_DATE = 'SET_MIN_END_DATE'
export const SET_MAX_MIN = 'SET_MAX_MIN'

export const minStartDate = moment().format()
export const minEndDate = moment(minStartDate).add(1, 'hour').format()
export const maxDate = moment().add(10, 'year').format()

const handleMinEndDate = (state, date) => {
  return R.isNil(state) ? moment(date).add(1, 'hours') : date
}

export const INIT_STATE = {
  [startDateTimeKey]: null,
  [endDateTimeKey]: null,
  lat: null,
  lng: null,
  timeZoneId: null,
  addressState: '',
  isOverriddenCoordinate: false,
  isShownEndTime: false,
  minStartDate: minStartDate,
  maxStartDate: maxDate,
  minEndDate: minEndDate,
  maxEndDate: maxDate,
  isStartDateError: false,
  errorStartDateMessage: undefined,
  isEndDateError: false,
  errorEndDateMessage: undefined,
  startTimezone: null,
  endTimezone: null,
}

export const createEventAttributes = ({
  startDateTime,
  endDateTime,
  lat,
  lng,
  timeZoneId,
  startTimezone,
  endTimezone,
}) => {
  return R.mergeRight(INIT_STATE, {
    [startDateTimeKey]: startDateTime,
    [endDateTimeKey]: endDateTime,
    lat,
    lng,

    timeZoneId,
    startTimezone,
    endTimezone,
  })
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TYPE_UPDATE_PARTIAL:
      return {
        ...state,
        [action.key]: action.value,
        minEndDate: action.minEnd,
      }
    case TYPE_UPDATE_ADDRESS:
      return {
        ...state,
        lat: action.lat,
        lng: action.lng,
        timeZoneId: action.timeZoneId,
        isOverriddenCoordinate: true,
      }
    case SET_TIMEZONE_AND_ADDRESS:
      return {
        ...state,
        lat: action.lat,
        lng: action.lng,
        timeZoneId: action.timeZoneId,
        startTimezone: action.timeZoneId,
        endTimezone: action.timeZoneId,
        addressState: action.address,
      }
    case TYPE_SET_INITIAL:
      return action.initialValue
    case SET_START_MIN_DATE:
      return {
        ...state,
        minStartDate: action.date,
      }
    case SET_OVERRIDDEN:
      return {
        ...state,
        isOverriddenCoordinate: true,
      }
    case SET_MAX_DATE:
      return {
        ...state,
        maxStartDate: action.date,
        maxEndDate: action.date,
      }
    case ON_SHOW_END_DATE_TIME:
      return {
        ...state,
        isShownEndTime: action.value,
      }
    case TYPE_CLEAR_DATE_ERROR:
      return {
        ...state,
        isEndDateError: false,
        errorEndDateMessage: undefined,
        isStartDateError: false,
        errorStartDateMessage: undefined,
      }
    case SET_TIMEZONE_START:
      return {
        ...state,
        startTimezone: action.startTimezone,
      }
    case SET_TIMEZONE_END:
      return {
        ...state,
        endTimezone: action.endTimezone,
      }
    case ON_CHANGE_DATE: {
      return {
        ...state,
        [action.key]: action.value,
        isShownEndTime: !R.isNil(action.value),
        minEndDate: handleMinEndDate(state.endDateTime, action.value),
      }
    }
    case SET_MIN_END_DATE: {
      return {
        ...state,
        minEndDate: handleMinEndDate(state.endDateTime, action.value),
      }
    }
    case SET_MAX_MIN: {
      return {
        ...state,
        minEndDate: action.minDate,
        maxStartDate: action.date,
        maxEndDate: action.date,
      }
    }
    default:
      return state
  }
}
